import ApiService from './api.service'

const SettingsService = {
  index () {
    return ApiService.get('api/v1/admin/settings')
  },
  storeBranding (data) {
    return ApiService.post('api/v1/admin/settings/branding', data)
  },
  storeBrandingWithoutLoading (data) {
    return ApiService.postWithoutLoading('api/v1/admin/settings/branding', data)
  },
  storeOrganization (data) {
    return ApiService.post('api/v1/admin/settings/organization', data)
  },
  storeWebsiteMeta (data) {
    return ApiService.post('api/v1/admin/settings/website-meta', data)
  },
  storeLivestream (data) {
    return ApiService.post('api/v1/admin/settings/livestream', data)
  },
  storeDefaults (data) {
    return ApiService.post('api/v1/admin/settings/defaults', data)
  },
  storeScheduleDefault (data) {
    return ApiService.post('api/v1/admin/settings/schedule-default', data)
  },
  storeNews (data) {
    return ApiService.post('api/v1/admin/settings/news', data)
  },
  generateUserTvCode () {
    return ApiService.postWithoutLoading('api/v1/admin/tv-code')
  },
  indexAboutUsPages () {
    return ApiService.get('api/v1/admin/about-us-pages')
  },
  storeAboutUsPage (data) {
    return ApiService.postWithoutLoading('api/v1/admin/about-us-pages', data)
  },
  updateAboutUsPage (uuid, data) {
    return ApiService.putWithoutLoading(`api/v1/admin/about-us-pages/${uuid}`, data)
  },
  changeOrderAboutUsPages (data) {
    return ApiService.putWithoutLoading('api/v1/admin/about-us-pages/change-order', data)
  },
  deleteAboutUsPage (uuid) {
    return ApiService.deleteWithoutLoading(`api/v1/admin/about-us-pages/${uuid}`)
  }
}

export default SettingsService
